var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload_file"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29565",
    "data-name": "Rectangle 29565",
    width: 46,
    height: 33,
    transform: "translate(447 896)",
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_725",
    "data-name": "Mask Group 725",
    transform: "translate(-447 -896)",
    clipPath: "url(#upload_file)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_18_",
    "data-name": "svgexport-7 (18)",
    transform: "translate(451.099 896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15074",
    "data-name": "Group 15074",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15073",
    "data-name": "Group 15073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15072",
    "data-name": "Group 15072"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149",
    "data-name": "Ellipse 3149",
    cx: 2.589,
    cy: 2.589,
    r: 2.589,
    transform: "translate(11.616 8.235)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12186",
    "data-name": "Path 12186",
    d: "M35.459,24.493A7.974,7.974,0,0,0,31,22.371V9.209a5.177,5.177,0,0,0-1.474-3.6,5.025,5.025,0,0,0-3.6-1.474H5.071a5.177,5.177,0,0,0-3.6,1.474A5.025,5.025,0,0,0,0,9.209V30.678a5.177,5.177,0,0,0,1.474,3.6,5.025,5.025,0,0,0,3.6,1.474H25.246A7.608,7.608,0,0,0,35.459,24.493ZM1.906,9.209a3.01,3.01,0,0,1,.935-2.194,3.156,3.156,0,0,1,2.23-.935H25.929a3.193,3.193,0,0,1,3.165,3.165v11.22l-5.322-5.322a.966.966,0,0,0-1.367,0L14.385,23.2l-5.43-5.466a.966.966,0,0,0-1.367,0L1.906,23.486ZM5.035,33.915v-.072a3.156,3.156,0,0,1-2.23-.935,3.282,3.282,0,0,1-.9-2.23V26.219l6.365-6.4,5.43,5.43a1,1,0,0,0,1.367,0l8.02-8.056,5.25,5.286-.324.108a3.34,3.34,0,0,0-.468.144c-.144.036-.288.108-.432.144a1.077,1.077,0,0,0-.288.144,3.342,3.342,0,0,0-.36.18l-.539.324c-.108.072-.18.108-.288.18-.072.036-.108.072-.18.108a4.339,4.339,0,0,0-.863.755,7.608,7.608,0,0,0-2.23,5.394,7.906,7.906,0,0,0,.18,1.582c.036.144.072.252.108.4.108.36.216.719.36,1.079v.036a6.6,6.6,0,0,0,.468.863Zm29.022,0a5.689,5.689,0,0,1-7.948.072c-.144-.144-.288-.324-.432-.468-.108-.108-.216-.252-.324-.36a3.415,3.415,0,0,1-.36-.611c-.072-.144-.144-.252-.216-.4a3.037,3.037,0,0,1-.18-.611c-.036-.144-.108-.324-.144-.468a5.952,5.952,0,0,1-.108-1.151A5.772,5.772,0,0,1,26,25.9a5.56,5.56,0,0,1,4.028-1.654A5.772,5.772,0,0,1,34.056,25.9a5.621,5.621,0,0,1,1.654,4.028A5.752,5.752,0,0,1,34.056,33.915Z",
    transform: "translate(0 -4.138)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12187",
    "data-name": "Path 12187",
    d: "M55.349,45.874a1.255,1.255,0,0,0-.324-.216,1.05,1.05,0,0,0-.324-.072h-.072a1.05,1.05,0,0,0-.324.072.849.849,0,0,0-.324.216l-2.23,2.23a.966.966,0,0,0,1.367,1.367l.575-.575v3.956a.971.971,0,1,0,1.942,0V48.895l.575.575A.966.966,0,0,0,57.578,48.1Z",
    transform: "translate(-24.637 -23.973)",
    fill: "#7e59d1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.bd081691790e5a04fdc7e3cba17656eb.svg";
export { ForwardRef as ReactComponent };